<script>
	import Dork from './components/Dork.svelte'
	let domain = ''

	let dorks = [
		{
			name: 'Directory listing (Index of /)',
			search: 'site:DOMAIN intitle:"Index of /"'
		},
		{
			name: 'Backup or senstive file (ext : txt, log, zip, ...)',
			search: 'site:DOMAIN ext:txt | ext:log | ext:cfg | ext:config | ext:yml | ext:sql | ext:env | ext:txt | ext:zip | ext:bak | ext:tar | ext:tar.gz'
		},
		{
			name: 'Confidentials docs file',
			search: 'site:DOMAIN ext:(doc | pdf | xls | txt | ps | rtf | odt | sxw | psw | ppt | pps | xml) intext:(confidential | salary | email)'
		},
		{
			name: 'Certificate or private keys',
			search: 'site:DOMAIN BEGIN (CERTIFICATE|DSA|RSA) filetype:key | filetype:csr'
		},
		{
			name: 'Senstive CSV file',
			search: 'site:DOMAIN intext:(username | userid | user | id | email | password samAccountName) filetype:csv'
		},
		{
			name: 'SQL information_schema',
			search : 'site:DOMAIN "information_schema" filetype:sql'
		},
		{
			name: 'Log files',
			search: 'site:DOMAIN filetype:log inurl:"access.log" +intext:"HTTP/1.1"'
		}
	]

	function createSearch(search, newDomain) {
		if (newDomain === '')
			return search.replace('DOMAIN', 'example.com');
		return search.replace('DOMAIN', newDomain)
	}
</script>

<main>
	<h1>Dorks builder</h1>
	<p>Enter your domain :</p>
	<input type="text" bind:value={domain} placeholder="example.com">

	{#each dorks as dork }
		<Dork name={dork.name} search={createSearch(dork.search, domain)} />
	{/each}
</main>

<style>
main {
	text-align: center;
}

h1 {
    padding-top: 10px;
}

p {
    font-size: 18px;
    text-align: center;
    padding: 0 0 5px 0;
}

input {
	padding: 8px;
	width: 20%;
	margin-bottom: 30px;
}
</style>